import {
  Configuration,
  ListConfiguration,
} from '../../../../types/Configuration';
import { IListCollectData } from '../../../../types/ListCollectData';
import { AppConfiguration } from '../../../Cards/AppConfiguration';
import { OpenCollectCard } from '../../../Cards/OpenCollectCard';
import { ListCardCollects } from '../styles';

export const ListAppConfigurations = ({ data }: ListConfiguration) => {
  return (
    <ListCardCollects>
      {data.map((configuration, key) => {
        return <AppConfiguration {...{ configuration }} {...{ key }} />;
      })}
    </ListCardCollects>
  );
};
